import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { audioApi } from 'services/apiDigitalTicket/audio';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';
import * as AudioActions from './actions';
import { AudioTypes } from './types';

function* getAudio({
  payload,
}: ReturnType<typeof AudioActions.getAudioRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(audioApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(AudioActions.getAudioSuccess({ audioLink: response.data }));
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('audio - get - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AudioActions.getAudioFailure());
    yield put(DialogsActions.setClose());
  }
}

function* createAudio({
  payload,
}: ReturnType<typeof AudioActions.createAudioRequest>): any {
  try {
    if (!payload.name) return;

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(audioApi.create, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        AudioActions.createAudioSuccess({ createdAudioLink: response.data }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('audio - create - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AudioActions.createAudioFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const audioSagas = [
  takeLatest(AudioTypes.GET_AUDIO_REQUEST, getAudio),
  takeLatest(AudioTypes.CREATE_AUDIO_REQUEST, createAudio),
];
